// Feature Flags
const parseBoolEnvFlag = (value: string | undefined): boolean => {
  return value === 'true'
}

export const isDevelopment = process.env.NODE_ENV === 'development'
export const showReportSummary = parseBoolEnvFlag(import.meta.env.VITE_FEATUREFLAG_SHOWSUMMARY)
export const showFilters = parseBoolEnvFlag(import.meta.env.VITE_FEATUREFLAG_SHOWFILTERS)
export const showImageComparison = parseBoolEnvFlag(import.meta.env.VITE_FEATUREFLAG_SHOWIMAGECOMPARISON)
